import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import sicrediStyle from 'assets/styles/default.scss';

export default makeStyles((theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 'auto',
    overflowX: 'hidden',
    overflowY: 'hidden',
  },
  pesquisa: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 56,
    backgroundColor: '#f8f9f7',
  },
  clearIcon: {
    fontSize: 9,
  },
  searchIcon: {
    color: sicrediStyle.primarySicrediDark,
  },
  tabs: {
    backgroundColor: '#f8f9f7',
    minHeight: 54,
  },
  tab: {
    minHeight: 54,
    fontSize: 14,
    fontWeight: 'normal',
    color: theme.palette.primary.main,
    textTransform: 'none',
    '&.Mui-selected': {
      fontWeight: 'bold',
    }
  },
  list: {
    padding: 8,
    maxHeight: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
  },
  item: {
    borderRadius: 10,
    backgroundColor: '#F7F7F7',
    margin: theme.spacing(1, 'auto'),
  },
  itemDestaque: {
    backgroundColor: 'white',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: sicrediStyle.primarySicredi,
    pointerEvents: 'none',
  },
  itemBadge: {
    flex: 'auto',
  },
  itemText: {
    display: 'flex',
    flexDirection: 'column',
    '& .MuiListItemText-primary': {
      display: 'flex',
      alignItems: 'center',
      fontFamily: '"Nunito"',
      fontSize: 16,
      fontWeight: 400,
    },
    '& .MuiListItemText-secondary': {
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      fontSize: 12,
      fontWeight: 300,
      color: sicrediStyle.secondarySicrediDarker,
    },
  }
}), { name: 'Duvidas' });
